import ko from '@tko/build.knockout';
import _ from 'lodash';
import Vue from 'vue';
import vuetify from '../../../../plugins/vuetify';
import FilterExpressionService from '../../services/filter.expression.service';
import UtilsService from '../../../../services/utils.service';
import FilterExpression from '../../../../vueComponents/filterExpression/src/filterExpression.vue';
import templateMarkup from 'raw-loader!./filter.template.html';

function FilterViewModel(params) {
  var self = this;
  self.initialize(params);
}

FilterViewModel.prototype = {
  initialize: function(params) {
    var self = this;
    self.subscriptions = [];
    self.columns = [];

    self.filterModel = _.get(params, 'filterModel');
    self.filterReadySignal = _.get(params, 'filterReadySignal');
    self.filterVisible = _.get(params, 'filterVisible', true);
    self.filterDatasetName = _.get(params, 'filterDatasetName');
    self.datasetName = ko.unwrap(self.filterDatasetName);

    // support both observable and string
    if (ko.isObservable(self.filterDatasetName)) {
      self.subscriptions.push(self.filterDatasetName.subscribe(datasetName => {
        self.datasetName = datasetName;
        if (self.vueFilter) {
          self.vueFilter.datasetName = self.datasetName;
        }
      }));
    }

    self.vueFilterHookID = 'vueFilterHook-' + UtilsService.generateID();

    self.availableTags = ko.observableArray();
    self.selectedTags = ko.observableArray();

    self.activeFilterExpression = self.filterModel && self.filterModel.getActiveFilters()
      ? self.filterModel.getActiveFilters() :
       { filterGroups: FilterExpressionService.getDefaultFilterExpression(), operator: 'and' };
    self.filterGroups = self.activeFilterExpression.filterGroups;

    self.filterModel.activeFiltersUpdated.add(function() {
      self.activeFilterExpression = self.filterModel.getActiveFilters();
      self.filterGroups.length = 0;
      self.filterGroups.push(...self.activeFilterExpression.filterGroups);
      if (self.vueFilter) {
        self.vueFilter.operator = self.activeFilterExpression.operator;
      }
    });

    self.updateFilterGroups = function(filterGroups) {
      self.activeFilterExpression.filterGroups = filterGroups;
      self.filterModel.setActiveFilters(self.activeFilterExpression);
    };

    self.updateOperator = function(newOperator) {
      self.activeFilterExpression.operator = newOperator;
      self.filterModel.setActiveFilters(self.activeFilterExpression);
    };

    self.filterModel.availableFiltersUpdated.add(function() {
      let availableFilters = self.filterModel.getAvailableFilters();
      // we need to update self.columns but using the same array object so the viewFilter will pick up the changes
      if (self.columns.length > 0) {
        self.columns.length = 0;
      }
      self.columns.push(...FilterExpressionService.getColumnsFromFilters(availableFilters));

      if (!self.vueFilter) {
        self.vueFilter = new Vue({
          el: '#' + self.vueFilterHookID,
          data: function() {
            return {
              columns: self.columns.filter(column => column.filterType !== 'none'),
              filterGroups: self.filterGroups,
              datasetName: self.datasetName,
              operator: self.activeFilterExpression.operator
            };
          },
          methods: {
            updateFilters: function(filterGroups) {
              self.updateFilterGroups(filterGroups);
            },
            updateOperator: function(operator) {
              self.updateOperator(operator);
            },
          },
          render(h) {
            return h('form', { attrs: { autocomplete: 'off' } }, [
              h(FilterExpression, {
                props: {
                  columns: this.columns,
                  filterGroups: this.filterGroups,
                  datasetName: this.datasetName,
                  operator: this.operator,
                },
                on: {
                  'filters-updated': this.updateFilters,
                  'operator-changed': this.updateOperator,
                }
              })
            ]);
          },
          vuetify
        });
      } else {
        self.vueFilter.columns = self.columns.filter(column => column.filterType !== 'none');
      }
    });
  },


  dispose: function() {
    var self = this;
    _.forEach(self.subscriptions, function(subscription) {
      subscription.dispose();
    });
    if (self.vueFilter) {
      self.vueFilter.$destroy();
      self.vueFilter.$el.parentNode.removeChild(self.vueFilter.$el);
    }
  }
};

ko.components.register('assurance-filter', { template: templateMarkup, viewModel: FilterViewModel });

export default FilterViewModel;
